import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreatePartResponse = ClientInferResponseBody<typeof contract.parts.create, 201>;

export type CreatePartRequestBody = ClientInferRequest<typeof contract.parts.create>["body"];

export const createPart = async (
  payload: CreatePartRequestBody,
): Promise<CreatePartResponse | null> => {
  const response = await api.parts.create.mutation({ body: payload });

  if (response.status === 201) {
    return response.body;
  }

  if (response.status === 403) {
    throw new ApiError(response.body.message, response.status, response.body);
  }

  return null;
};
